export default "__VITE_ASSET__DWibp9Sy__"